import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import SvgIcon from '../SvgIcon.js';
var IconIcSlackSquare = props => /*#__PURE__*/
// eslint-disable-next-line react/jsx-props-no-spreading
React.createElement(SvgIcon, _extends({}, props, {
  viewBox: "0 0 40 40",
  iconname: "IconIcSlackSquare"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pathTo_Svg__Clip0_13076_197460)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 0.5H34C37.0376 0.5 39.5 2.96243 39.5 6V34C39.5 37.0376 37.0376 39.5 34 39.5H6C2.96243 39.5 0.5 37.0376 0.5 34V6C0.5 2.96243 2.96243 0.5 6 0.5Z",
  fill: "white",
  stroke: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.2661 6C14.7183 6.00114 13.4656 7.25723 13.4667 8.80503C13.4656 10.3528 14.7194 11.6089 16.2672 11.6101H19.0677V8.80618C19.0688 7.25838 17.815 6.00229 16.2661 6C16.2672 6 16.2672 6 16.2661 6ZM16.2661 13.4816H8.80046C7.25266 13.4828 5.99886 14.7388 6 16.2866C5.99772 17.8344 7.25151 19.0905 8.79932 19.0928H16.2661C17.8139 19.0917 19.0677 17.8356 19.0665 16.2878C19.0677 14.7388 17.8139 13.4828 16.2661 13.4816Z",
  fill: "#36C5F0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.9962 16.2866C33.9973 14.7388 32.7435 13.4828 31.1957 13.4816C29.6479 13.4828 28.3941 14.7388 28.3953 16.2866V19.0928H31.1957C32.7435 19.0917 33.9973 17.8356 33.9962 16.2866ZM26.5295 16.2866V8.80503C26.5306 7.25838 25.2779 6.00229 23.7301 6C22.1823 6.00114 20.9285 7.25723 20.9297 8.80503V16.2866C20.9274 17.8344 22.1812 19.0905 23.729 19.0928C25.2768 19.0917 26.5306 17.8356 26.5295 16.2866Z",
  fill: "#2EB67D"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.7301 34.0569C25.2779 34.0557 26.5317 32.7996 26.5306 31.2518C26.5317 29.704 25.2779 28.4479 23.7301 28.4468H20.9297V31.2518C20.9285 32.7985 22.1823 34.0546 23.7301 34.0569ZM23.7301 26.5741H31.1969C32.7447 26.573 33.9985 25.3169 33.9973 23.7691C33.9996 22.2213 32.7458 20.9652 31.198 20.9629H23.7313C22.1835 20.964 20.9297 22.2201 20.9308 23.7679C20.9297 25.3169 22.1823 26.573 23.7301 26.5741Z",
  fill: "#ECB22E"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 23.7679C5.99886 25.3157 7.25266 26.5718 8.80046 26.573C10.3483 26.5718 11.6021 25.3157 11.6009 23.7679V20.9629H8.80046C7.25266 20.964 5.99886 22.2201 6 23.7679ZM13.4667 23.7679V31.2495C13.4645 32.7973 14.7183 34.0534 16.2661 34.0557C17.8139 34.0546 19.0677 32.7985 19.0665 31.2507V23.7702C19.0688 22.2224 17.815 20.9663 16.2672 20.964C14.7183 20.964 13.4656 22.2201 13.4667 23.7679Z",
  fill: "#E01E5A"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pathTo_Svg__Clip0_13076_197460"
}, /*#__PURE__*/React.createElement("rect", {
  width: "40",
  height: "40",
  fill: "white"
}))));
export { IconIcSlackSquare as default };
//# sourceMappingURL=IconIcSlackSquare.js.map